import { usePaginatedQuery, useUrlPaginatedQuery } from "@shared/hooks";
import type { PaginatedQueryParams } from "@shared/api";
import { axiosGetData } from "@shared/api/clients";
import { useQuery } from "@tanstack/react-query";

import {
  ClientDetail,
  ClientFilters,
  ListClientsResponse,
} from "./clients.types";

const CLIENTS_ENDPOINT = "v1/managerial/tenants";
const CLIENTS_QUERY_KEY = ["clients"];

export const CLIENTS_FILTER_KEYS: (keyof ClientFilters)[] = [
  "name",
  "fantasyName",
  "cnpj",
  "responsibleName",
  "sortBy",
  "sortOrder",
];

export const getClient = async (id: string): Promise<ClientDetail> => {
  return axiosGetData<ClientDetail>(`${CLIENTS_ENDPOINT}/${id}`);
};

export const useClientQuery = (id: string, options = {}) => {
  return useQuery({
    queryKey: [...CLIENTS_QUERY_KEY, id],
    queryFn: () => getClient(id),
    enabled: !!id,
    ...options,
  });
};

export const useClientsQuery = (
  params?: PaginatedQueryParams<ClientFilters>,
) => {
  return usePaginatedQuery<ListClientsResponse, ClientFilters>({
    endpoint: CLIENTS_ENDPOINT,
    queryKeyBase: CLIENTS_QUERY_KEY,
    params,
  });
};

export const useClientsUrlQuery = () => {
  return useUrlPaginatedQuery<ListClientsResponse, ClientFilters>({
    endpoint: CLIENTS_ENDPOINT,
    queryKeyBase: CLIENTS_QUERY_KEY,
    filterKeys: CLIENTS_FILTER_KEYS,
  });
};
